import { GridCellParams } from '@mui/x-data-grid-pro';
import { GridCustomColDef } from '../../types';
import { formatPercent, formatPrice } from '../../../utils/helpers';

export const monthlyRecurringColumns: GridCustomColDef[] = [
  {
    field: 'id',
    headerName: '',
    headerAlign: 'left',
    align: 'left',
    cellClassName: 'grey-background',
    minWidth: 120,
    flex: 1,
    type: 'singleSelect',
    sortable: false,
    filterable: false,
    hideable: false
  },
  {
    field: 'expected',
    headerName: 'Expected',
    headerAlign: 'right',
    align: 'right',
    minWidth: 120,
    flex: 1,
    type: 'singleSelect',
    sortable: false,
    filterable: false,
    valueFormatter: (value) => value,
    renderCell: (params: GridCellParams) => (
      <span className={params.value && (params.value as number) < 0 ? 'text-price-red' : ''}>
        {params.row.id == 'MRR % of MRC' ? formatPercent(params.value as number) : formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'actual',
    headerName: 'Actual',
    headerAlign: 'right',
    align: 'right',
    minWidth: 120,
    flex: 1,
    type: 'singleSelect',
    sortable: false,
    filterable: false,
    valueFormatter: (value) => value,
    renderCell: (params: GridCellParams) => (
      <span className={params.value && (params.value as number) < 0 ? 'text-price-red' : ''}>
        {params.row.id == 'MRR % of MRC' ? formatPercent(params.value as number) : formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'difference',
    headerName: 'Difference',
    headerAlign: 'right',
    align: 'right',
    minWidth: 120,
    flex: 1,
    type: 'singleSelect',
    sortable: false,
    filterable: false,
    valueFormatter: (value) => value,
    renderCell: (params: GridCellParams) => (
      <span className={params.value && (params.value as number) < 0 ? 'text-price-red' : ''}>
        {params.row.id == 'MRR % of MRC' ? formatPercent(params.value as number) : formatPrice(params.value as number)}
      </span>
    )
  }
];
